import { SuperModel } from './super-model.model';
import { EChildPositionIcon, EChildPositionIconColor, EChildPositionTooltip } from '@enums';

export class RouteLog extends SuperModel {
  eventTime: Date | string;
  eventType: string;
  beaconInfo: string;
  childInfo: string;
  childStatus: string;
  locationTime?: Date | string;
  firstPositionChangeLocationLatitude?: number;
  firstPositionChangeLocationLink?: string;
  firstPositionChangeLocationLongitude?: number;
  firstPositionChangeLocationTime?: Date | string;
  beaconTime?: Date | string;
  locationLink?: string;
  latitude?: number;
  longitude?: number;
  address?: string;
  driverInfo?: string;
  busInfo?: string;
  routePlanInfo?: string;
  childrenListInfo?: string;
  message?: string;
  isAbsent?: boolean;
  stateChangeSource?: string;
  stateChangedByUserInfo?: string;

  constructor(data: any = {}) {
    super(data);
    if (data.eventTime) {
      this.eventTime = new Date(data.eventTime);
    }
    if (data.locationTime) {
      this.locationTime = new Date(data.locationTime);
    }
    if (data.beaconTime) {
      this.beaconTime = new Date(data.beaconTime);
    }
    if (data.firstPositionChangeLocationTime) {
      this.firstPositionChangeLocationTime = new Date(data.firstPositionChangeLocationTime);
    }
  }

  get statusIcon() {
    if (!this.childStatus) {
      return null;
    }
    const status = String(this.childStatus)
      .toUpperCase()
      .replace(/-/g, '_');
    if (!EChildPositionIcon[status]) {
      return null;
    }
    return {
      icon: EChildPositionIcon[status],
      color: EChildPositionIconColor[status],
      tooltip: EChildPositionTooltip[status],
    };
  }

  get serialised() {
    return {
      id: this.id,
      eventTime: this.eventTime,
      eventType: this.eventType,
      beaconInfo: this.beaconInfo,
      childInfo: this.childInfo,
      childStatus: this.childStatus,
      locationLink: this.locationLink,
      latitude: this.latitude,
      longitude: this.longitude,
      address: this.address,
      driverInfo: this.driverInfo,
      busInfo: this.busInfo,
      routePlanInfo: this.routePlanInfo,
      childrenListInfo: this.childrenListInfo,
      message: this.message,
      isAbsent: this.isAbsent,
      stateChangeSource: this.stateChangeSource,
      stateChangedByUserInfo: this.stateChangedByUserInfo,
    };
  }
}
